import { render } from "./LeaveApproverForm.vue?vue&type=template&id=1eca8522&scoped=true"
import script from "./LeaveApproverForm.vue?vue&type=script&lang=js"
export * from "./LeaveApproverForm.vue?vue&type=script&lang=js"

import "./LeaveApproverForm.vue?vue&type=style&index=0&id=1eca8522&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eca8522"]])

export default __exports__